angular.module('admin.directives')

  .directive('legal', ['AgentService', 'PageNotificationService', '$state', 'AccountService', 'SessionService', function(AgentService, PageNotificationService, $state, AccountService, SessionService){
    return {
      restrict: '',
      controllerAs: 'legalCtrl',
      bindToController: {},
      scope: {},
      templateUrl: '/admin/templates/partials/legal.html',

      controller: function(){
        var ctrl = this;

        ctrl.agentHasLoaded = function(){
          return !_.isEmpty(AccountService.getAgent());
        };

        ctrl.requiresLegalAcceptance = function(){
          return !SessionService.isImpersonating() && !Boolean(AccountService.getAgent('legalAcceptedAt'));
        };

        ctrl.acceptLegal = function() {
          if(ctrl.acceptedLegal){
            let acceptedAt = moment().toDate();

            AgentService.acceptTerms(AccountService.getAgent('id'))
              .then(() => {
                let agent = AccountService.getAgent();
                agent.legalAcceptedAt = acceptedAt;
                AccountService.set(agent);
                PageNotificationService.close();
              })
              .catch((err) => {
                PageNotificationService.error('There was an error saving agent profile. ' + err);
              });
          }else{
            PageNotificationService.error('Please accept the Terms of Service and Privacy Policy before continuing.');
          }
        };
      },

      link: function($scope, el, attrs, ctrl){

      }
    };

  }]);
